module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMEgwLjUyOTQxMkMwLjIzNzE3NiAwIDAgMC4yMzcxNzYgMCAwLjUyOTQxMkMwIDAuODIxNjQ3IDAuMjM3MTc2IDEuMDU4ODIgMC41Mjk0MTIgMS4wNTg4Mkg5QzkuMjkyMjMgMS4wNTg4MiA5LjUyOTQxIDAuODIxNjQ3IDkuNTI5NDEgMC41Mjk0MTJDOS41Mjk0MSAwLjIzNzE3NiA5LjI5MjIzIDAgOSAwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4yMzUzNSA4LjQ3MDcpIiBmaWxsPSIjMjM5NkZDIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/svg/minus-blue.svg
// module id = /nqw
// module chunks = 1